import React, { useEffect, useRef, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { onAuthStateChanged } from "firebase/auth";
import { Link } from "react-router-dom";
import { auth, functions } from "../firebase";

export default function FreshBooksOAuthCallback() {
  const [status, setStatus] = useState("Connecting FreshBooks…");
  const [error, setError] = useState("");
  const startedRef = useRef(false);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const oauthError = query.get("error");
    const oauthErrorDescription = query.get("error_description");
    const code = query.get("code");
    const state = query.get("state");

    if (oauthError) {
      setError(oauthErrorDescription || oauthError);
      setStatus("");
      return undefined;
    }

    if (!code || !state) {
      setError("FreshBooks did not return the required authorization details.");
      setStatus("");
      return undefined;
    }

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (startedRef.current) return;
      startedRef.current = true;

      if (!user) {
        setError(
          "Your admin session is no longer active. Sign in and start the FreshBooks connection again."
        );
        setStatus("");
        return;
      }

      try {
        const completeOAuth = httpsCallable(functions, "completeFreshBooksOAuth");
        const result = await completeOAuth({ code, state });
        if (!result?.data?.success) {
          throw new Error("FreshBooks returned an unexpected connection response.");
        }
        window.history.replaceState({}, document.title, "/oauth/callback");
        setStatus("FreshBooks is connected. Future token refreshes are automatic.");
      } catch (callbackError) {
        console.error("FreshBooks OAuth callback failed", callbackError);
        setError(callbackError?.message || "FreshBooks could not be connected.");
        setStatus("");
      }
    });

    return unsubscribe;
  }, []);

  return (
    <div style={{ maxWidth: 680, margin: "48px auto", padding: 24 }}>
      <h1 style={{ marginBottom: 12 }}>FreshBooks connection</h1>
      {status ? <p>{status}</p> : null}
      {error ? (
        <div
          role="alert"
          style={{
            background: "#fef2f2",
            border: "1px solid #fca5a5",
            borderRadius: 8,
            color: "#991b1b",
            padding: 12,
          }}
        >
          {error}
        </div>
      ) : null}
      <p style={{ marginTop: 20 }}>
        <Link to="/admin">Return to the admin dashboard</Link>
      </p>
    </div>
  );
}
